import React from 'react';
import { Container } from 'reactstrap';
import NotFoundIllustration from '../images/404-illustration.jpg';
import {PrimaryButton} from "./Buttons";

export default function NotFoundPage() {
  return (
    <section className="py-5 text-center">
      <Container>
        {/* Pre-image text */}
        <h2 className="h3 fw-bold mb-4">Page Not Found</h2>

        {/* Full-width illustration */}
        <img
          src={NotFoundIllustration}
          alt="404 illustration"
          className="img-fluid w-100 mb-4"
          style={{ maxHeight: '60vh', objectFit: 'cover' }}
        />

        <p className="lead text-muted mb-4">
          Sorry, the page you’re looking for doesn’t exist or has been moved.
        </p>

        <PrimaryButton href="/">
          ⬅️ Back to Home
        </PrimaryButton>
      </Container>
    </section>
  );
}
